import React, { useState } from "react";
import qs from "query-string";
import { Link } from "react-router-dom";
import { usePaginatedQuery } from "react-query";

import {
    MainContainer,
    TitleContainer,
    MainTitle,
    ColumnContainer,
    Column,
    SimpleTable,
    ButtonsRow,
    MainButton
} from "@beacharound/beacharound-ui";

import { getRooms, updateRoom } from "../../../../../api/hotels/rooms";
import PublishPopup from "../../../../../components/Popups/PublishPopup";

export default function Rooms({ history, match, location }) {
    
    const { elementId } = match.params;
    const { page } = location.search ? qs.parse(location.search) : { page: "0" };

    const [ limit, setLimit ] = useState(25);
    const [ publishItem, setPublishItem ] = useState();

    const options = {
        skip: Number(page) * limit,
        limit,
        sort: { name: 1 },
        params: {}
    }
    
    const { data, isLoading } = usePaginatedQuery(["hotels", elementId, "rooms", options], () =>
        getRooms({elementId, params: options})
    );

    const tableHead = [{
        text: "Nome",
        key: "name",
        sort: "text",
        highlight: true,
        default: true,
        image: (item) => item?.cover,
    },{
        text: "Letti",
        key: "beds",
        sort: true,
        flex: 0.5,
        hasMobileLabel: true,
        parse: (item) => {
            let beds = 0;
            item.map((el) => beds += el.quantity)
            return beds
        }
    },{
        flex: 0.5,
        actions: (item) => {
            return [{
                icon: item.published ? "visible" : "not-visible",
                action: () => setPublishItem(item),
            },{
                icon: "edit",
                component: Link,
                to: `${match.url}/${item._id}`,
            }]
        }
    }]

    const tableRows = data || [];

    return (
        <MainContainer large>

            <ColumnContainer noMargin>
                <Column column={2}>
                    <TitleContainer noMargin>
                        <MainTitle text="Camere dell'hotel" />
                    </TitleContainer>
                </Column>
                <Column column={2}>
                    <ButtonsRow flexEnd noMargin>
                        <MainButton text="Nuova camera" component={Link} to={`${match.url}/create`}/>
                    </ButtonsRow>
                </Column>
            </ColumnContainer>

            <ColumnContainer>
                <Column>
                    <SimpleTable
                        match={match}
                        history={history}
                        setLimit={setLimit}
                        navigation
                        data={tableRows}
                        head={tableHead}
                        isLoading={isLoading}
                        page={page}
                    />
                </Column>
            </ColumnContainer>

            <PublishPopup
                elementId={elementId}
                item={publishItem}
                setItem={setPublishItem}
                type={"rooms"}
                queryKey={["hotels", elementId, "rooms", options]}
                updateFunction={updateRoom}
            />
        </MainContainer>
    );
}
